import React from 'react';

import {
  setStatusBarBackgroundColor,
  setStatusBarStyle,
  setStatusBarTranslucent,
} from 'expo-status-bar';
import { Platform } from 'react-native';

import { primitive } from 'styles/constants/primitives';
import { isItemPickerOrComboRoute } from 'utils/routing';

export const useMenuObjPageStatusBarForAndroid = (pathname: string) => {
  React.useEffect(() => {
    if (Platform.OS !== 'android') {
      return;
    }

    if (isItemPickerOrComboRoute(pathname)) {
      setStatusBarTranslucent(false);
      setStatusBarBackgroundColor(primitive.$black, false);
      setStatusBarStyle('light', false);
    }

    return () => {
      // reset to app defaults
      setStatusBarTranslucent(true);
      setStatusBarBackgroundColor('transparent', false);
      setStatusBarStyle('dark', false);
    };
  }, [pathname]);
};
